<div class="image" [class.no-image]="isLoading && img">
  @if (imgSrc) {
    <img
      draggable="false"
      [style.transform]="rotateAngle ? 'rotate(' + rotateAngle + 'deg)' : undefined"
      [class.plug]="!isLoading && imgSrc === plugImgSrc"
      [src]="imgSrc"
      [alt]="imgSrc"
      [style]="imgStyle"
    />
  }
</div>
